import { NgModule } from '@angular/core';
import { ModalAttentionRetirementComponent } from '../modal-attention-retirement/modal-attention-retirement.component';
import { ModalIdRetirementComponent } from '../modal-id-retirement/modal-id-retirement.component';
import { ModalSuccessRetirementComponent } from './modal-success-retirement.component';

/**
 * Reexporta modais standalone do novo DS.
 */
@NgModule({
  imports: [
    ModalSuccessRetirementComponent,
    ModalIdRetirementComponent,
    ModalAttentionRetirementComponent,
  ],
  exports: [
    ModalSuccessRetirementComponent,
    ModalIdRetirementComponent,
    ModalAttentionRetirementComponent,
  ],
})
export class WithdrawalResultModalModule {}
